import { TFunction } from 'react-i18next'

import { PlatformAdmin, PROJECT_ADMIN_TYPE } from 'lib/authorization/Roles'
import { PARTICIPANT_STATUS } from 'lib/GlobalConstants'
import { ShowAlert } from 'types/Alert'
interface ParticipantSummary {
  blocked: boolean
  type: string
  status: string
  unsubscribed: boolean
  id: string
  login: string
  email: string
  createdAt: string
  lastSeenAt: string
  activated: boolean
  unconfirmedEmail: boolean
}

export const onItemSelection = async (
  option: string,
  setCurrentModal: (arg0: string) => void,
  setOpen: (arg0: boolean) => void,
  showAlert: ShowAlert,
  sendActivationMail: (id: string) => Promise<any>,
  id: string,
  t: TFunction,
  getParticipant: () => void,
  activateParticipant: (id: string) => Promise<any>,
) => {
  if (
    [
      'susbscribeToNewsletter',
      'blockParticipant',
      'unblockParticipant',
      'upgradeToProjectAdmin',
    ].includes(option)
  ) {
    setCurrentModal(option)
  }

  if (option == 'resendActivationMail') {
    await handelSendActivationClick(sendActivationMail, id, showAlert, t)
    getParticipant()
  }

  if (option === 'activateParticipant') {
    await handelActivateParticipantClick(activateParticipant, id, showAlert, t)
    getParticipant()
  }

  setOpen(false)
}

export const handlePRMActionButtonsClosure = (
  event: { target: any },
  anchorRef: { current: { contains: (arg0: any) => any } } | null,
  setOpen: (arg0: boolean) => void,
) => {
  if (
    anchorRef &&
    anchorRef.current &&
    anchorRef.current.contains(event.target as HTMLElement)
  ) {
    return
  }
  setOpen(false)
}

export const handelSendActivationClick = async (
  sendActivationMail: (id: string) => Promise<any>,
  participantID: string,
  showAlert: ShowAlert,
  t: TFunction,
) => {
  showAlert({
    type: 'info',
    title: t('participant.actions.sendActivationMail.loading'),
    icon: 'circularProgressWhite',
  })
  const result = await sendActivationMail(participantID)
  if (result && result.code) {
    showAlert({
      type: 'error',
      title: t('participant.actions.sendActivationMail.error'),
    })
  } else {
    showAlert({
      type: 'success',
      title: t('participant.actions.sendActivationMail.success'),
    })
  }
}

export const formOptionsForParticipant = (
  participantSummary: ParticipantSummary,
  roleName: string,
) => {
  const optionList = []
  const { blocked, type, status, unsubscribed } = participantSummary
  const { pendingActivation, active } = PARTICIPANT_STATUS
  if (blocked && status !== pendingActivation) {
    optionList.push('unblockParticipant')
  }
  if (!blocked && status !== pendingActivation) {
    optionList.push('blockParticipant')
  }

  if (type !== PROJECT_ADMIN_TYPE && status === active)
    optionList.push('upgradeToProjectAdmin')

  if (status === pendingActivation) optionList.push('resendActivationMail')

  if (status === pendingActivation && roleName === PlatformAdmin)
    optionList.push('activateParticipant')

  if (unsubscribed) optionList.push('susbscribeToNewsletter')

  return optionList
}

export const handelActivateParticipantClick = async (
  activateParticipant: (id: string) => Promise<any>,
  participantID: string,
  showAlert: ShowAlert,
  t: TFunction,
) => {
  showAlert({
    type: 'info',
    title: t('participant.actions.activateParticipant.loading'),
    icon: 'circularProgressWhite',
  })
  const result = await activateParticipant(participantID)
  if (result && result.code) {
    showAlert({
      type: 'error',
      title: t('participant.actions.activateParticipant.error'),
    })
  } else {
    showAlert({
      type: 'success',
      title: t('participant.actions.activateParticipant.success'),
    })
  }
}
